import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';


// Dil dosyaları
const resources = {
  en: {
    translation: {
      "language": "English",
      "TerminalHeader": "Terminal - Anıl Orhan",
      "WelcomeMessage": "Welcome to Anıl Orhan's terminal. Type 'help' to see available commands.",
      "ClassicPageInfo": "If you're not familiar with command line interfaces, you can use the classic page view.",
      "SwitchToClassicPage": "Click here to switch to classic page view",
      "Divider": "─",
      "UnknownCommand": "Command not found:",
      "CommandInputPlaceholder": "Type a command...",
      "AutocompleteOptions": "Autocomplete options:",
      "AvailableCommands": "Available commands:",
      
      // SEO Metinleri
      "seo": {
        "title": "Anıl Orhan | Software Developer & Solution Architect",
        "description": "Software developer specialized in .NET, ASP.NET Core, and web technologies with experience in backend development and solution architecture.",
        "keywords": "Anıl Orhan, software developer, .NET, ASP.NET Core, backend developer, web development, C#, SQL, entity framework, RESTful API",
        "services": {
          "title": "Consulting & Freelance Services | Anıl Orhan",
          "description": "Professional software development services including backend development, system architecture design, database solutions, and legacy code modernization.",
          "keywords": "backend development, .NET services, software consulting, system architecture, database integration, legacy code modernization, devops services"
        }
      },
      
      "homePage": {
        "tagline": "Software Developer & Solution Architect",
        "openTerminal": "Open Terminal",
        "goToServices": "View Services"
      },
      
      "theme": {
        "cmd": "Windows Command Prompt",
        "powershell": "Windows PowerShell",
        "ubuntu": "Ubuntu Terminal"
      },
      "commands": {
        "help": {
          "description": "Show available commands"
        },
        "clear": {
          "description": "Clear the terminal screen"
        },
        "about": {
          "description": "Display information about me"
        },
        "skills": {
          "description": "List my technical skills"
        },
        "projects": {
          "description": "Show my projects"
        },
        "experience": {
          "description": "Show my work experience"
        },
        "education": {
          "description": "Show my education background"
        },
        "contact": {
          "description": "Display contact information"
        },
        "cv": {
          "description": "Download my CV (use 'cv tr' for Turkish version)"
        },
        "theme": {
          "description": "Change terminal theme (cmd, powershell, ubuntu)"
        },
        "language": {
          "description": "Change language (en, tr)"
        },
        "echo": {
          "description": "Display a message"
        },
        "date": {
          "description": "Show current date and time"
        },
        "github": {
          "description": "Open my GitHub profile"
        },
        "linkedin": {
          "description": "Open my LinkedIn profile"
        },
        "twitter": {
          "description": "Open my Twitter profile"
        },
        "classic": {
          "description": "Switch to classic page view"
        },
        "services": {
          "description": "Show consulting & freelance services"
        },
        "homepage": {
          "description": "Switch to home page view"
        }
      },
      "parameters": {
        "language": "Language code (en, tr)",
        "theme": "Theme name (cmd, powershell, ubuntu)",
        "text": "Text to display"
      },
      "about": {
        "title": "About Me",
        "content": "I am Anıl Orhan, a .NET developer. I focus on developing efficient and sustainable solutions while working with C# and .NET Core. I value teamwork and am highly motivated to continuously learn. I aim to deepen my expertise in backend technologies and deliver innovative solutions."
      },
      "skills": {
        "title": "My Skills",
        "languages": "Programming Languages: C#, JavaScript, SQL, Java",
        "backend": "Backend: .NET Core, ASP.NET MVC, Entity Framework Core, Web API, REST, GraphQL,SignalR",
        "frontend": "Frontend: React, Redux, HTML5, CSS3, SASS, Bootstrap",
        "databases": "Databases: MS SQL Server, PostgreSQL, MongoDB, Redis, Elasticsearch",
        "tools": "Tools & DevOps: Visual Studio, VS Code, Git, Docker, Azure, CI/CD, Jenkins"
      },
      "projects": {
        "title": "My Projects",
        "project1": {
          "title": "PrintOmi",
          "description": "A startup offering document printing services through a mobile app, placing printers in popular locations.",
          "technologies": "Technologies: .NET Core 5.0, Flutter, Entity Framework, Fluent Validation, AutoMapper, Ninject"
        },
        "project2": {
          "title": "Bak Nerede",
          "description": "A tour guide platform developed for an external client.",
          "technologies": "Technologies: PHP, .NET Web API, Google Maps API, Entity Framework, AutoMapper, FluentValidation, Serilog, Redis"
        },
        "project3": {
          "title": "Cario",
          "description": "Vehicle tracking system.",
          "technologies": "Technologies: .NET Core 7.0, MQTT, MongoDB, Jenkins, Docker, Redis, Portainer"
        },
        "project4": {
          "title": "Smartgatex",
          "description": "AI-powered license plate recognition system.",
          "technologies": "Technologies: .NET Core, Python, Docker, RESTful API"
        },
        "project5": {
          "title": "Digidoc",
          "description": "Spare part supply and catalog application. A web application providing vehicle maintenance, fault codes, and a visual catalog, with API integrations with external systems.",
          "technologies": "Technologies: .NET Core, Quartz, RabbitMQ, Elastic"
        },
        "project6": {
          "title": "Filo Online",
          "description": "A platform for fleet managers to track accidents, thefts, insurance, expert reports, and service processes.",
          "technologies": "Technologies: .NET Framework"
        },
        "project7": {
          "title": "Network Plan",
          "description": "An application integrating fleets and services with parts suppliers and simulating tender processes.",
          "technologies": "Technologies: RESTful API, SOAP web services, job scheduling, log management, integration management"
        },
        "project8": {
          "title": "GT Motive Integration",
          "description": "A platform integrating spare part supply processes with GT Motive.",
          "technologies": "Technologies: RESTful API, SOAP API"
        }
      },
      "experience": {
        "title": "Work Experience",
        "job1": {
          "title": "Backend Developer",
          "company": "Digilera BT",
          "period": "August 2023 - Present",
          "description": "Working as a backend developer at a company providing software solutions to the automotive industry, with over 10 active products. We collaborate across projects. Our products include fleet management systems, spare part supply systems, etc. We use Agile-Scrum methodology to maintain fast and efficient development processes."
        },
        "job2": {
          "title": "Backend Developer",
          "company": "Unilogistix Co.",
          "period": "November 2022 - August 2023",
          "description": "Worked on the development of a vehicle tracking system, including web applications, database management, and CI/CD processes. Gained valuable experience as the sole backend developer of the company."
        },
        "job3": {
          "title": "Software Developer",
          "company": "Vodases Telecom",
          "period": "June 2022 - November 2022",
          "description": "Gained my first professional software development experience at this software agency, working on various projects involving mobile development with Flutter, web development with PHP, and web applications with .NET Core."
        }
      },
      "ClassicPage": {
        "tagline": "Software Developer & Solution Architect",
        "nav": {
          "about": "About",
          "skills": "Skills",
          "experience": "Experience",
          "projects": "Projects",
          "education": "Education",
          "downloadCV": "Download CV"
        },
        "about": {
          "title": "About Me",
          "content": "I'm Anıl Orhan, a passionate software developer specializing in .NET technologies and web development. With extensive experience in building robust and scalable applications, I focus on writing clean, maintainable code and implementing efficient solutions. I have strong expertise in backend development with ASP.NET Core and frontend technologies like React and Angular."
        },
        "skills": {
          "title": "My Skills",
          "content": "Programming Languages: C#, JavaScript, TypeScript, Python, SQL, Java\nBackend: .NET Core, ASP.NET MVC, Entity Framework Core, Web API, REST, GraphQL, Identity Server, SignalR\nFrontend: React, Angular, Redux, HTML5, CSS3, SASS, Bootstrap, Material UI\nDatabases: MS SQL Server, PostgreSQL, MongoDB, Redis, Elasticsearch\nTools & DevOps: Visual Studio, VS Code, Git, Docker, Kubernetes, Azure, CI/CD, Jenkins, TeamCity",
          "categories": [
            { "name": "Languages", "items": ["C#", "JavaScript", "TypeScript", "Python", "SQL", "Java"] },
            { "name": "Backend", "items": [".NET Core", "ASP.NET MVC", "Entity Framework Core", "Web API", "REST", "GraphQL", "Identity Server", "SignalR"] },
            { "name": "Frontend", "items": ["React", "Angular", "Redux", "HTML5", "CSS3", "SASS", "Bootstrap", "Material UI"] },
            { "name": "Databases", "items": ["MS SQL Server", "PostgreSQL", "MongoDB", "Redis", "Elasticsearch"] },
            { "name": "Tools & DevOps", "items": ["Visual Studio", "VS Code", "Git", "Docker", "Kubernetes", "Azure", "CI/CD", "Jenkins", "TeamCity"] }
          ]
        },
        "experience": {
          "title": "Work Experience",
          "content": "Backend Developer - Digilera BT (August 2023 - Present)\nI work as a backend developer at a company that provides software solutions to the automotive industry and develops over 10 active products. We work on various products such as fleet management systems and spare parts supply systems. Our team collaborates across projects to develop software solutions. We apply the Agile-Scrum methodology for fast and efficient development processes.\n\nBackend Developer - Unilogistix Co. (November 2022 - August 2023)\nI worked as a backend developer at Unilogistix for 10 months. I contributed to the development of the vehicle tracking system, web applications, database management, CI/CD processes, and project planning. As the sole backend developer, I gained significant experience.\n\nSoftware Developer - Vodases Telecom (June 2022 - November 2022)\nI worked on various projects involving mobile development with Flutter, web development with PHP, and web applications with .NET Core. This experience provided me the opportunity to work across a broad technical spectrum.",
          "jobs": [
            {
              "title": "Backend Developer",
              "company": "Digilera BT",
              "period": "August 2023 - Present",
              "description": "I work as a backend developer at a company that provides software solutions to the automotive industry and develops over 10 active products. We work on various products such as fleet management systems and spare parts supply systems. Our team collaborates across projects to develop software solutions. We apply the Agile-Scrum methodology for fast and efficient development processes.",
              "tags": [".NET Core", "Docker", "Agile", "SQL Server", "REST API"]
            },
            {
              "title": "Backend Developer",
              "company": "Unilogistix Co.",
              "period": "November 2022 - August 2023",
              "description": "I worked as a backend developer at Unilogistix for 10 months. I contributed to the development of the vehicle tracking system, web applications, database management, CI/CD processes, and project planning. As the sole backend developer, I gained significant experience.",
              "tags": [".NET Core", "MongoDB", "MQTT", "CI/CD", "Jenkins"]
            },
            {
              "title": "Software Developer",
              "company": "Vodases Telecom",
              "period": "June 2022 - November 2022",
              "description": "I worked on various projects involving mobile development with Flutter, web development with PHP, and web applications with .NET Core. This experience provided me the opportunity to work across a broad technical spectrum.",
              "tags": ["Flutter", "PHP", ".NET Core", "Mobile"]
            }
          ]
        },
        "projects": {
          "title": "My Projects",
          "content": "PrintOmi: An initiative that places printers in popular locations, allowing customers to print documents via a mobile app. (Technologies: .NET Core 5.0, Flutter, Entity Framework, Fluent Validation, AutoMapper, Ninject)\n\nBak Nerede: A tour guide platform developed for an external client. (Technologies: PHP, .NET Web API, Google Maps API, Entity Framework, AutoMapper, FluentValidation, Serilog, Redis)\n\nCario: A vehicle tracking system. (Technologies: .NET Core 7.0, MQTT, MongoDB, Jenkins, Docker, Redis, Portainer)\n\nSmartgatex: An AI-powered license plate recognition system. (Technologies: .NET Core, Python, Docker, RESTful API)\n\nDigidoc: A spare parts supply and catalog application. (Technologies: .NET Core, Quartz, RabbitMQ, Elastic)\n\nFilo Online: A platform for fleet managers to track accident, theft, insurance, and service processes. (Technologies: .NET Framework)\n\nNetwork Plan: An application that integrates fleet and service providers with spare parts supply processes and simulates bidding processes. (Technologies: RESTful API, SOAP web services, job scheduling, log management, integration management)\n\nGT Motive Integration: A platform that integrates spare parts supply processes with GT Motive. (Technologies: RESTful API, SOAP API)",
          "items": [
            { "name": "PrintOmi", "description": "An initiative that places printers in popular locations, allowing customers to print documents via a mobile app.", "tags": [".NET Core 5.0", "Flutter", "Entity Framework", "AutoMapper"] },
            { "name": "Bak Nerede", "description": "A tour guide platform developed for an external client.", "tags": ["PHP", ".NET Web API", "Google Maps API", "Redis"] },
            { "name": "Cario", "description": "A vehicle tracking system.", "tags": [".NET Core 7.0", "MQTT", "MongoDB", "Docker", "Redis"] },
            { "name": "Smartgatex", "description": "An AI-powered license plate recognition system.", "tags": [".NET Core", "Python", "Docker", "RESTful API"] },
            { "name": "Digidoc", "description": "A spare parts supply and catalog application.", "tags": [".NET Core", "Quartz", "RabbitMQ", "Elastic"] },
            { "name": "Filo Online", "description": "A platform for fleet managers to track accident, theft, insurance, and service processes.", "tags": [".NET Framework"] },
            { "name": "Network Plan", "description": "An application that integrates fleet and service providers with spare parts supply processes and simulates bidding processes.", "tags": ["RESTful API", "SOAP", "Job Scheduling"] },
            { "name": "GT Motive Integration", "description": "A platform that integrates spare parts supply processes with GT Motive.", "tags": ["RESTful API", "SOAP API"] }
          ]
        },
        "education": {
          "title": "Education Background",
          "content": "Computer Programming - Atatürk University (2022 - 2024)\nEducation on advanced programming concepts, software development methodologies, and practical application development skills.\n\nBusiness Administration (Tourism) - Balıkesir University (2015 - 2019)\nEducation on business management principles, marketing strategies, and tourism industry operations.\n\nSoftware Expertise Training Program - Technical University Of America - Academy\nIntensive training on modern software development practices, design patterns, and industry-standard tools and frameworks.",
          "items": [
            { "degree": "Computer Programming", "institution": "Atatürk University", "period": "2022 - 2024" },
            { "degree": "Business Administration (Tourism)", "institution": "Balıkesir University", "period": "2015 - 2019" },
            { "degree": "Software Expertise Training Program", "institution": "Technical University Of America - Academy", "period": "" }
          ]
        },
        "footer": {
          "text": "© 2025 Anıl Orhan. All rights reserved.",
          "easterEggHint": "Press 'ALT+M' for a surprise",
          "shiftEHint": "Or try 'Shift+E'"
        },
        "switchToTerminal": "Switch to Terminal View",
        "switchToServices": "Services"
      },
      "services": {
        "title": "Consulting & Freelance Services",
        "description": "I offer consulting and freelance services in backend development and solution architecture that will take your business to the next level.",
        "service1": {
          "title": "Backend Development",
          "description": "Development of fast, reliable, and scalable web services and backend systems with modern .NET technologies. Solutions that automate your business processes and easily integrate with other systems."
        },
        "service2": {
          "title": "System Architecture Design",
          "description": "Design of software architectures tailored to your business needs, ready for growth and easy to manage. Systems that can work smoothly even under high load, with easy maintenance."
        },
        "service3": {
          "title": "Legacy Code Renewal",
          "description": "Modernizing aging and slowing applications to resolve performance and security issues. Renewing your system infrastructure while preserving your existing business logic."
        },
        "service4": {
          "title": "Database and Integration",
          "description": "Efficient, secure, and fast database solutions. Setup of integration systems that automate data exchange with your business partners and suppliers, and management of scheduled operations."
        },
        "service5": {
          "title": "DevOps and Infrastructure",
          "description": "Accelerating application development and deployment processes. Early detection of issues by monitoring your systems and providing uninterrupted service with automatic scaling."
        },
        "service6": {
          "title": "Code Review & Mentoring",
          "description": "Improving code quality with professional code reviews. Knowledge sharing on .NET development best practices, architecture patterns, and performance optimization techniques."
        },
        "contact": {
          "title": "Get in Touch",
          "subtitle": "Feel free to contact me for your projects or questions.",
          "whatsapp": {
            "title": "WhatsApp",
            "description": "Contact me via WhatsApp for quick responses and immediate communication.",
            "button": "Send Message"
          },
          "email": {
            "title": "Email",
            "description": "Send me an email to discuss your project in detail or to get more information.",
            "button": "Send Email"
          },
          "linkedin": {
            "title": "LinkedIn",
            "description": "Follow me on my professional network and connect with me on LinkedIn.",
            "button": "View Profile"
          }
        },
        "backButton": "Go Back"
      },
      "settings": {
        "theme": "Theme",
        "language": "Language",
        "performanceModeEnable": "Enable Performance Mode",
        "performanceModeDisable": "Disable Performance Mode",
        "title": "Settings"
      },
      "help": {
        "title": "AVAILABLE COMMANDS",
        "systemCommands": "SYSTEM COMMANDS:",
        "infoCommands": "INFORMATION COMMANDS:",
        "navigationCommands": "NAVIGATION COMMANDS:",
        "socialCommands": "SOCIAL MEDIA COMMANDS:",
        "miscCommands": "MISCELLANEOUS COMMANDS:"
      },
      
      "navigation": {
        "switchingToHomePage": "Switching to Home Page...",
        "switchingToClassic": "Switching to Classic Page View...",
        "switchingToServices": "Switching to Services Page..."
      },

      "themes": {
        "title": "Available Themes:",
        "command": "Use 'theme <name>' to change the theme (e.g., 'theme ubuntu')"
      }
    }
  },
  tr: {
    translation: {
      "language": "Türkçe",
      "TerminalHeader": "Terminal - Anıl Orhan",
      "WelcomeMessage": "Anıl Orhan'ın terminaline hoş geldiniz. Kullanılabilir komutları görmek için 'help' yazın.",
      "ClassicPageInfo": "Komut satırı arayüzlerine aşina değilseniz, klasik sayfa görünümünü kullanabilirsiniz.",
      "SwitchToClassicPage": "Klasik sayfa görünümüne geçmek için buraya tıklayın",
      "Divider": "─",
      "UnknownCommand": "Komut bulunamadı:",
      "CommandInputPlaceholder": "Bir komut yazın...",
      "AutocompleteOptions": "Otomatik tamamlama seçenekleri:",
      "AvailableCommands": "Kullanılabilir komutlar:",
      
      // SEO Metinleri
      "seo": {
        "title": "Anıl Orhan | Yazılım Geliştirici & Çözüm Mimarı",
        "description": ".NET, ASP.NET Core, ve web teknolojileri konularında uzmanlaşmış backend developer.",
        "keywords": "Anıl Orhan, yazılım geliştirici, .NET, ASP.NET Core, backend developer, web geliştirme, C#, SQL, entity framework, RESTful API",
        "services": {
          "title": "Danışmanlık & Freelance Hizmetleri | Anıl Orhan",
          "description": "Backend geliştirme, sistem mimarisi tasarımı, veritabanı çözümleri ve legacy kod modernizasyonu içeren profesyonel yazılım geliştirme hizmetleri.",
          "keywords": "backend geliştirme, .NET hizmetleri, yazılım danışmanlığı, sistem mimarisi, veritabanı entegrasyonu, legacy kod yenileme, devops hizmetleri"
        }
      },
      
      "homePage": {
        "tagline": "Yazılım Geliştirici & Çözüm Mimarı",
        "openTerminal": "Terminali Aç",
        "goToServices": "Hizmetleri Görüntüle"
      },
      
      "theme": {
        "cmd": "Windows Komut İstemi",
        "powershell": "Windows PowerShell",
        "ubuntu": "Ubuntu Terminal"
      },
      "commands": {
        "help": {
          "description": "Kullanılabilir komutları göster"
        },
        "clear": {
          "description": "Terminal ekranını temizle"
        },
        "about": {
          "description": "Hakkımda bilgileri göster"
        },
        "skills": {
          "description": "Teknik yeteneklerimi listele"
        },
        "projects": {
          "description": "Projelerimi göster"
        },
        "experience": {
          "description": "İş deneyimimi göster"
        },
        "education": {
          "description": "Eğitim geçmişimi göster"
        },
        "contact": {
          "description": "İletişim bilgilerini göster"
        },
        "cv": {
          "description": "CV'mi indir (Türkçe versiyonu için 'cv tr' kullanın)"
        },
        "theme": {
          "description": "Terminal temasını değiştir (cmd, powershell, ubuntu)"
        },
        "language": {
          "description": "Dili değiştir (en, tr)"
        },
        "echo": {
          "description": "Bir mesaj göster"
        },
        "date": {
          "description": "Mevcut tarih ve saati göster"
        },
        "github": {
          "description": "GitHub profilimi aç"
        },
        "linkedin": {
          "description": "LinkedIn profilimi aç"
        },
        "twitter": {
          "description": "Twitter profilimi aç"
        },
        "classic": {
          "description": "Klasik sayfa görünümüne geç"
        },
        "services": {
          "description": "Danışmanlık ve freelance hizmetlerini göster"
        },
        "homepage": {
          "description": "Ana sayfa görünümüne geç"
        }
      },
      "parameters": {
        "language": "Dil kodu (en, tr)",
        "theme": "Tema adı (cmd, powershell, ubuntu)",
        "text": "Gösterilecek metin"
      },
      "about": {
        "title": "Hakkımda",
        "content": "Ben Anıl Orhan, .NET geliştiricisiyim. C# ve .NET Core üzerinde çalışıyor, verimli ve sürdürülebilir çözümler üretmeye odaklanıyorum. Takım çalışmasına önem veriyor, sürekli öğrenmeye motivasyonla yaklaşıyorum. Backend teknolojilerinde derinleşip yenilikçi çözümler sunmak istiyorum."
      },
      "skills": {
        "title": "Yeteneklerim",
        "languages": "Programlama Dilleri: C#, JavaScript, SQL, Java",
        "backend": "Backend: .NET Core, ASP.NET MVC, Entity Framework Core, Web API, REST, GraphQL, SignalR",
        "frontend": "Frontend: React, Redux, HTML5, CSS3, SASS, Bootstrap",
        "databases": "Veritabanları: MS SQL Server, PostgreSQL, MongoDB, Redis, Elasticsearch",
        "tools": "Araçlar & DevOps: Visual Studio, VS Code, Git, Docker, Azure, CI/CD, Jenkins"
      },
      "projects": {
        "title": "Projelerim",
        "project1": {
          "title": "PrintOmi",
          "description": "Mobil uygulama üzerinden belge baskı hizmeti sunan ve yazıcılarını popüler mekanlara yerleştiren bir girişim.",
          "technologies": "Teknolojiler: .NET Core 5.0, Flutter, Entity Framework, Fluent Validation, AutoMapper, Ninject"
        },
        "project2": {
          "title": "Bak Nerede",
          "description": "Dış müşteri için geliştirilen tur rehberlik platformu.",
          "technologies": "Teknolojiler: PHP, .NET Web API, Google Maps API, Entity Framework, AutoMapper, FluentValidation, Serilog, Redis"
        },
        "project3": {
          "title": "Cario",
          "description": "Araç takip sistemi.",
          "technologies": "Teknolojiler: .NET Core 7.0, MQTT, MongoDB, Jenkins, Docker, Redis, Portainer"
        },
        "project4": {
          "title": "Smartgatex",
          "description": "Yapay zeka destekli plaka tanıma sistemi.",
          "technologies": "Teknolojiler: .NET Core, Python, Docker, RESTful API"
        },
        "project5": {
          "title": "Digidoc",
          "description": "Yedek parça tedarik ve katalog uygulaması. Araç bakım, arıza kodları ve görsel katalog sunan web uygulaması, dış sistemlerle entegre olabilen API'lar içeriyor.",
          "technologies": "Teknolojiler: .NET Core, Quartz, RabbitMQ, Elastic"
        },
        "project6": {
          "title": "Filo Online",
          "description": "Büyük filo yöneticileri için kaza-çalınma yönetimi ve sigorta, expertiz, servis süreçlerini izleme platformu.",
          "technologies": "Teknolojiler: .NET Framework"
        },
        "project7": {
          "title": "Network Plan",
          "description": "Filo ve servisleri, parça tedarikçileriyle entegre eden ve ihale süreçlerini simüle eden bir uygulama.",
          "technologies": "Teknolojiler: RESTful API, SOAP web servisleri, job scheduling, log yönetimi, entegrasyon yönetimi"
        },
        "project8": {
          "title": "GT Motive Entegrasyonu",
          "description": "Yedek parça tedarik süreçlerini optimize eden, GT Motive ile entegre bir platform.",
          "technologies": "Teknolojiler: RESTful API, SOAP API"
        }
      },
      "experience": {
        "title": "İş Deneyimi",
        "job1": {
          "title": "Backend Developer",
          "company": "Digilera BT",
          "period": "Ağustos 2023 - Halen",
          "description": "Otomotiv sektörüne yazılım çözümleri sunan ve 10'dan fazla aktif ürün geliştiren bir firmada backend geliştirici olarak çalışıyorum. Projeler arası iş birliği yaparak katkı sağlıyoruz. Filo yönetim sistemleri, yedek parça tedarik sistemleri gibi çeşitli alanlarda yer alıyoruz. Agile-Scrum metodolojisi ile hızlı ve verimli geliştirme süreçleri yürütüyoruz."
        },
        "job2": {
          "title": "Backend Developer",
          "company": "Unilogistix Co.",
          "period": "Kasım 2022 - Ağustos 2023",
          "description": "Araç takip sisteminin geliştirilmesinde, web uygulamaları, veritabanı yönetimi ve CI/CD süreçlerinde yer aldım. Şirketin tek backend geliştiricisi olarak önemli deneyimler kazandım."
        },
        "job3": {
          "title": "Software Developer",
          "company": "Vodases Telecom",
          "period": "Haziran 2022 - Kasım 2022",
          "description": "İlk profesyonel yazılım geliştirme deneyimimi kazandığım bu yazılım ajansında, Flutter ile mobil geliştirme, PHP ile web geliştirme ve .NET Core ile web uygulamaları geliştirme gibi çeşitli projelerde yer aldım."
        }
      },
      "contact": {
        "title": "İletişim Bilgileri",
        "email": "E-posta: contact@anilorhan.dev",
        "phone": "Telefon: +90 554 125 62 68"
      },
      "ClassicPage": {
        "tagline": "Yazılım Geliştirici & Çözüm Mimarı",
        "nav": {
          "about": "Hakkımda",
          "skills": "Yetenekler",
          "experience": "Deneyim",
          "projects": "Projeler",
          "education": "Eğitim",
          "downloadCV": "CV İndir"
        },
        "about": {
          "title": "Hakkımda",
          "content": "Ben Anıl Orhan, .NET teknolojileri ve web geliştirme konusunda uzmanlaşmış tutkulu bir yazılım geliştiricisiyim. Sağlam ve ölçeklenebilir uygulamalar geliştirme konusunda geniş deneyime sahibim ve temiz, bakımı kolay kod yazma ve verimli çözümler uygulama konusunda odaklanıyorum. ASP.NET Core ile backend geliştirme ve React ve Angular gibi frontend teknolojileri konusunda güçlü uzmanlığa sahibim."
        },
        "skills": {
          "title": "Yeteneklerim",
          "content": "Programlama Dilleri: C#, JavaScript, TypeScript, Python, SQL, Java\nBackend: .NET Core, ASP.NET MVC, Entity Framework Core, Web API, REST, GraphQL, Identity Server, SignalR\nFrontend: React, Angular, Redux, HTML5, CSS3, SASS, Bootstrap, Material UI\nVeritabanları: MS SQL Server, PostgreSQL, MongoDB, Redis, Elasticsearch\nAraçlar & DevOps: Visual Studio, VS Code, Git, Docker, Kubernetes, Azure, CI/CD, Jenkins, TeamCity",
          "categories": [
            { "name": "Diller", "items": ["C#", "JavaScript", "TypeScript", "Python", "SQL", "Java"] },
            { "name": "Backend", "items": [".NET Core", "ASP.NET MVC", "Entity Framework Core", "Web API", "REST", "GraphQL", "Identity Server", "SignalR"] },
            { "name": "Frontend", "items": ["React", "Angular", "Redux", "HTML5", "CSS3", "SASS", "Bootstrap", "Material UI"] },
            { "name": "Veritabanları", "items": ["MS SQL Server", "PostgreSQL", "MongoDB", "Redis", "Elasticsearch"] },
            { "name": "Araçlar & DevOps", "items": ["Visual Studio", "VS Code", "Git", "Docker", "Kubernetes", "Azure", "CI/CD", "Jenkins", "TeamCity"] }
          ]
        },
        "experience": {
          "title": "İş Deneyimi",
          "content": "Backend Developer - Digilera BT (Ağustos 2023 - Günümüz)\nOtomotiv sektörüne yazılım çözümleri sunan ve 10'dan fazla aktif ürün geliştiren bir şirkette backend developer olarak görev yapıyorum. Filo yönetim sistemleri, yedek parça tedarik sistemleri ve daha birçok ürün üzerinde çalışıyoruz. Ekip olarak projeler arası işbirliği ile yazılım çözümleri geliştiriyoruz. Hızlı ve verimli geliştirme süreçleri için Agile-Scrum metodolojisini uyguluyoruz.\n\nBackend Developer - Unilogistix Co. (Kasım 2022 - Ağustos 2023)\nUnilogistix'te 10 ay süreyle backend developer olarak görev aldım. Araç takip sistemi geliştirilmesinde, web uygulamaları, veritabanı yönetimi, CI/CD süreçleri ve proje planlamasında önemli katkılar sağladım. Şirketin tek backend geliştiricisi olarak büyük deneyimler kazandım.\n\nSoftware Developer - Vodases Telecom (Haziran 2022 - Kasım 2022)\nFlutter ile mobil geliştirme, PHP ile web geliştirme ve .NET Core ile web uygulamaları geliştirme gibi çeşitli projelerde görev aldım. Bu deneyim, geniş bir teknik yelpazede çalışma fırsatı sundu.",
          "jobs": [
            {
              "title": "Backend Developer",
              "company": "Digilera BT",
              "period": "Ağustos 2023 - Günümüz",
              "description": "Otomotiv sektörüne yazılım çözümleri sunan ve 10'dan fazla aktif ürün geliştiren bir şirkette backend developer olarak görev yapıyorum. Filo yönetim sistemleri, yedek parça tedarik sistemleri ve daha birçok ürün üzerinde çalışıyoruz.",
              "tags": [".NET Core", "Docker", "Agile", "SQL Server", "REST API"]
            },
            {
              "title": "Backend Developer",
              "company": "Unilogistix Co.",
              "period": "Kasım 2022 - Ağustos 2023",
              "description": "Unilogistix'te 10 ay süreyle backend developer olarak görev aldım. Araç takip sistemi geliştirilmesinde, web uygulamaları, veritabanı yönetimi, CI/CD süreçleri ve proje planlamasında önemli katkılar sağladım.",
              "tags": [".NET Core", "MongoDB", "MQTT", "CI/CD", "Jenkins"]
            },
            {
              "title": "Software Developer",
              "company": "Vodases Telecom",
              "period": "Haziran 2022 - Kasım 2022",
              "description": "Flutter ile mobil geliştirme, PHP ile web geliştirme ve .NET Core ile web uygulamaları geliştirme gibi çeşitli projelerde görev aldım.",
              "tags": ["Flutter", "PHP", ".NET Core", "Mobile"]
            }
          ]
        },
        "projects": {
          "title": "Projelerim",
          "content": "PrintOmi: Popüler lokasyonlara yazıcılar yerleştirerek müşterilerin mobil uygulama üzerinden belge baskısı alabileceği bir girişim. (Teknolojiler: .NET Core 5.0, Flutter, Entity Framework, Fluent Validation, AutoMapper, Ninject)\n\nBak Nerede: Dış bir müşteri için geliştirilen bir tur rehberliği platformu. (Teknolojiler: PHP, .NET Web API, Google Maps API, Entity Framework, AutoMapper, FluentValidation, Serilog, Redis)\n\nCario: Araç takip sistemi. (Teknolojiler: .NET Core 7.0, MQTT, MongoDB, Jenkins, Docker, Redis, Portainer)\n\nSmartgatex: Yapay zeka destekli plaka tanıma sistemi. (Teknolojiler: .NET Core, Python, Docker, RESTful API)\n\nDigidoc: Yedek parça tedarik ve katalog uygulaması. (Teknolojiler: .NET Core, Quartz, RabbitMQ, Elastic)\n\nFilo Online: Filo yöneticilerinin kaza, hırsızlık, sigorta ve hizmet süreçlerini takip edebileceği platform. (Teknolojiler: .NET Framework)\n\nNetwork Plan: Filo ve hizmet sağlayıcılarıyla yedek parça tedarik süreçlerini entegre eden ve ihale süreçlerini simüle eden bir uygulama. (Teknolojiler: RESTful API, SOAP web servisleri, iş zamanlaması, log yönetimi, entegrasyon yönetimi)\n\nGT Motive Entegrasyonu: Yedek parça tedarik süreçlerini GT Motive ile entegre eden bir platform. (Teknolojiler: RESTful API, SOAP API)",
          "items": [
            { "name": "PrintOmi", "description": "Popüler lokasyonlara yazıcılar yerleştirerek müşterilerin mobil uygulama üzerinden belge baskısı alabileceği bir girişim.", "tags": [".NET Core 5.0", "Flutter", "Entity Framework", "AutoMapper"] },
            { "name": "Bak Nerede", "description": "Dış bir müşteri için geliştirilen bir tur rehberliği platformu.", "tags": ["PHP", ".NET Web API", "Google Maps API", "Redis"] },
            { "name": "Cario", "description": "Araç takip sistemi.", "tags": [".NET Core 7.0", "MQTT", "MongoDB", "Docker", "Redis"] },
            { "name": "Smartgatex", "description": "Yapay zeka destekli plaka tanıma sistemi.", "tags": [".NET Core", "Python", "Docker", "RESTful API"] },
            { "name": "Digidoc", "description": "Yedek parça tedarik ve katalog uygulaması.", "tags": [".NET Core", "Quartz", "RabbitMQ", "Elastic"] },
            { "name": "Filo Online", "description": "Filo yöneticilerinin kaza, hırsızlık, sigorta ve hizmet süreçlerini takip edebileceği platform.", "tags": [".NET Framework"] },
            { "name": "Network Plan", "description": "Filo ve hizmet sağlayıcılarıyla yedek parça tedarik süreçlerini entegre eden ve ihale süreçlerini simüle eden bir uygulama.", "tags": ["RESTful API", "SOAP", "İş Zamanlaması"] },
            { "name": "GT Motive Entegrasyonu", "description": "Yedek parça tedarik süreçlerini GT Motive ile entegre eden bir platform.", "tags": ["RESTful API", "SOAP API"] }
          ]
        },
        "education": {
          "title": "Eğitim Geçmişi",
          "content": "Bilgisayar Programcılığı - Atatürk Üniversitesi (2022 - 2024)\nİleri programlama kavramları, yazılım geliştirme metodolojileri ve pratik uygulama geliştirme becerileri üzerine eğitim.\n\nİşletme (Turizm) - Balıkesir Üniversitesi (2015 - 2019)\nİşletme yönetimi prensipleri, pazarlama stratejileri ve turizm sektörü operasyonları konularında eğitim.\n\nYazılım Uzmanlığı Eğitim Programı - Technical University Of America - Academy\nModern yazılım geliştirme uygulamaları, tasarım desenleri ve endüstri standardı araçlar ve çerçeveler üzerine yoğun eğitim.",
          "items": [
            { "degree": "Bilgisayar Programcılığı", "institution": "Atatürk Üniversitesi", "period": "2022 - 2024" },
            { "degree": "İşletme (Turizm)", "institution": "Balıkesir Üniversitesi", "period": "2015 - 2019" },
            { "degree": "Yazılım Uzmanlığı Eğitim Programı", "institution": "Technical University Of America - Academy", "period": "" }
          ]
        },
        "footer": {
          "text": "© 2025 Anıl Orhan. Tüm hakları saklıdır.",
          "easterEggHint": "Sürpriz için 'ALT+M' tuşlarına basın",
          "shiftEHint": "Veya 'Shift+E' deneyebilirsiniz"
        },
        "switchToTerminal": "Terminal Görünümüne Geç",
        "switchToServices": "Hizmetler"
      },
      "services": {
        "title": "Danışmanlık & Freelance Hizmetleri",
        "description": "İşinizi bir üst seviyeye taşıyacak backend geliştirme ve çözüm mimarisi alanlarında danışmanlık ve freelance hizmetleri sunuyorum.",
        "service1": {
          "title": "Backend Geliştirme",
          "description": "Modern .NET teknolojileri ile hızlı, güvenilir ve ölçeklenebilir web servisleri ve arkayüz sistemleri geliştirme. İş süreçlerinizi otomatize eden, diğer sistemlerle kolayca entegre olan çözümler."
        },
        "service2": {
          "title": "Sistem Mimarisi Tasarımı",
          "description": "İşinizin ihtiyaçlarına uygun, büyümeye hazır ve yönetimi kolay yazılım mimarileri tasarımı. Yüksek yük altında bile sorunsuz çalışabilen, bakımı kolay sistemler."
        },
        "service3": {
          "title": "Legacy Kod Yenileme",
          "description": "Eskiyen ve yavaşlayan uygulamalarınızı modern teknolojilere taşıyarak performans ve güvenlik sorunlarını giderme. Mevcut iş mantığınızı koruyarak sistem altyapınızı yenileme."
        },
        "service4": {
          "title": "Veritabanı ve Entegrasyon",
          "description": "Verimli, güvenli ve hızlı veritabanı çözümleri. İş ortaklarınız ve tedarikçilerinizle veri alışverişini otomatize eden entegrasyon sistemleri kurulumu ve zamanlı işlemlerin yönetimi."
        },
        "service5": {
          "title": "DevOps ve Altyapı",
          "description": "Uygulama geliştirme ve yayınlama süreçlerini hızlandırma. Sistemlerinizi izleyerek sorunları erkenden tespit etme ve otomatik ölçeklendirme ile kesintisiz hizmet sağlama."
        },
        "service6": {
          "title": "Kod İnceleme & Mentorluk",
          "description": "Kod kalitesini artırmak için kapsamlı kod incelemeleri. Junior ve mid-level geliştiriciler için mentorluk ve en iyi uygulama rehberliği."
        },
        "contact": {
          "title": "İletişime Geçin",
          "subtitle": "Projeleriniz veya sorularınız için benimle iletişime geçebilirsiniz.",
          "whatsapp": {
            "title": "WhatsApp",
            "description": "Hızlı yanıt almak ve mesajlaşmak için WhatsApp üzerinden iletişime geçin.",
            "button": "Mesaj Gönder"
          },
          "email": {
            "title": "E-posta",
            "description": "Detaylı bilgi almak ve projenizi anlatmak için e-posta gönderebilirsiniz.",
            "button": "E-posta Gönder"
          },
          "linkedin": {
            "title": "LinkedIn",
            "description": "Profesyonel ağımda beni takip edebilir ve bağlantı kurabilirsiniz.",
            "button": "Profili Görüntüle"
          }
        },
        "backButton": "Geri Dön"
      },
      "settings": {
        "theme": "Tema",
        "language": "Dil",
        "performanceModeEnable": "Performans Modunu Aktifleştir",
        "performanceModeDisable": "Performans Modunu Deaktifleştir",
        "title": "Ayarlar"
      },
      "help": {
        "title": "KULLANILABİLİR KOMUTLAR",
        "systemCommands": "SİSTEM KOMUTLARI:",
        "infoCommands": "BİLGİ KOMUTLARI:",
        "navigationCommands": "NAVİGASYON KOMUTLARI:",
        "socialCommands": "SOSYAL MEDYA KOMUTLARI:",
        "miscCommands": "DİĞER KOMUTLAR:"
      },
      
      "navigation": {
        "switchingToHomePage": "Ana Sayfaya geçiliyor...",
        "switchingToClassic": "Klasik Sayfa Görünümüne geçiliyor...",
        "switchingToServices": "Hizmetler Sayfasına geçiliyor..."
      },
      
      "themes": {
        "title": "Kullanılabilir Temalar:",
        "command": "Tema değiştirmek için 'theme <tema-adı>' komutunu kullanın (örn. 'theme ubuntu')"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    lng: localStorage.getItem('preferred-language') || 'tr', // Varsayılan dil
    debug: false,
    interpolation: {
      escapeValue: false // React zaten XSS'den korunduğu için
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'preferred-language',
      caches: ['localStorage']
    },
    // Önemli: Dil değişiminde komponentlerin yeniden yüklenmesini engelleyen ayarlar
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      nsMode: 'default'
    }
  });

export default i18n; 